module.exports = __webpack_public_path__ + "img/start.a724e2be.png";